<template>
    <v-container fluid>
        <v-row class="flex-child">
            <v-col cols="12">
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
<!--                            <v-col cols="12" md="6" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    label="请输入type"-->
<!--                                    v-model="testType"-->
<!--                                />-->
<!--                            </v-col>-->
<!--                            <v-col cols="12" md="6" sm="6" xs="3">-->
<!--                                <v-btn color="primary mr-3" @click="queryByType" dark large>-->
<!--                                    <v-icon left>mdi-magnify</v-icon>-->
<!--                                    queryByType-->
<!--                                </v-btn>-->
<!--                            </v-col>-->
                            <!----------------------------------------------------------------------------------------->
                            <v-col cols="12" md="4" sm="6" xs="3">
                                <v-text-field
                                        solo
                                        hide-details
                                        :label="$vuetify.lang.t('$vuetify.custom.dict.dictId')"
                                        v-model="searchData.id"
                                />
                            </v-col>
                            <v-col cols="12" md="4" sm="6" xs="3">
                                <v-text-field
                                        solo
                                        hide-details
                                        :label="$vuetify.lang.t('$vuetify.custom.dict.dataType')"
                                        v-model="searchData.dataType"
                                />
                            </v-col>
                            <v-col cols="12" md="4" sm="6" xs="3">
                                <v-text-field
                                        solo
                                        hide-details
                                        :label="$vuetify.lang.t('$vuetify.custom.dict.dataCode')"
                                        v-model="searchData.dataCode"
                                />
                            </v-col>
                            <v-col cols="12" md="4" sm="6" xs="3">
                                <v-text-field
                                        solo
                                        hide-details
                                        :label="$vuetify.lang.t('$vuetify.custom.dict.dataValue')"
                                        v-model="searchData.dataValue"
                                />
                            </v-col>
                            <!--第二行-->
                            <v-col cols="12" md="4" sm="3" xs="3">
                                <v-text-field
                                        solo
                                        hide-details
                                        :label="$vuetify.lang.t('$vuetify.custom.dict.dataDesc')"
                                        v-model="searchData.dataDesc"
                                />
                            </v-col>
                            <v-col cols="12" md="4" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn v-5="permissionCode.search" color="primary mr-3" @click="loadData" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.add" color="success mr-3" @click="addDictRoot"  dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.addBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.exportPic" color="success mr-3" @click="exportImg"  dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        导出图片
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col cols="12" ref="exportDemo">
                <el-table
                        :data="tableData"
                        row-key="id"
                        border
                        default-expand-all
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column
                            prop="id"
                            label="字典ID"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="dataType"
                            label="数据类型"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="dataCode"
                            label="数据编码"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="dataValue"
                            label="数据名称/值"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="dictOrder"
                            label="排序码"
                            sortable>
                    </el-table-column>
                    <el-table-column
                            prop="dataDesc"
                            label="数据描述"
                            sortable>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <v-btn class="mx-1" small color="primary" v-5="permissionCode.update"  @click="handleEdit(scope.$index, scope.row)">
                                <v-icon dark>mdi-update</v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.dict.editBtn') }}
                            </v-btn>
                            <v-btn class="mx-1" small color="success" v-5="permissionCode.addChildren"  @click="handleAddChild(scope.$index, scope.row)">
                                <v-icon dark>mdi-plus</v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.dict.addChildBtn') }}
                            </v-btn>
                        </template>
                    </el-table-column>
                </el-table>
            </v-col>
            <v-dialog v-model="dialog" persistent max-width="700px">
                <dict-add-edit v-model="dialog" :dictId="dictId" :dataType="dataType" :dataObj="dataObj" :isAdd="isAdd" :opTime="opTime" @initialize="loadData"></dict-add-edit>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import {Table,TableColumn} from '@/plugins/element'
    import DictAddEdit from './dict-add-edit'
    import html2canvas from 'html2canvas'
    export default {
        name: "dict",
        components:{
            DictAddEdit,
            Table,
            TableColumn
        },
        data() {
            return {
                permissionCode:{
                    search:'sys:dict:search',
                    add:'sys:dict:add',
                    exportPic:'sys:dict:export:pic',
                    update:'sys:dict:update',
                    addChildren:'sys:dict:add:children',
                },
                //testType : 'jj',
                dialog : false,
                dictId : '',
                dataType : '',
                dataObj : {},
                isAdd : true,
                opTime : '',
                searchData:{
                    id : null,
                    dataType : null,
                    dataCode : null,
                    dataValue : null,
                    dataDesc : null
                },
                tableData: [],
            }
        },
        mounted(){
           this.loadData();
        },
        methods: {
            addDictRoot(){
                this.opTime = new Date().getTime();
                this.dataObj = {};
                this.dialog=true;
                this.isAdd=true;
            },
            handleEdit(index, row) {
                this.isAdd = false;
                this.opTime = new Date().getTime();
                this.dataObj = row;
                this.dialog = true;
            },
            handleAddChild(index, row) {
                this.dictId = row.id;
                this.dataType = row.dataCode;
                this.addDictRoot();
            },
            loadData(){
                this.$api.sysDict.dictList(this.searchData).then(res => {
                    if (res.flag) {
                        this.tableData = res.data;
                    }
                })
            },
            // queryByType(){
            //     this.$api.common.getDictByType(this.testType).then(res => {
            //         if (res.flag) {
            //             console.info(this.testType,res.data);
            //         }
            //     })
            // }
            exportImg(){
                html2canvas(this.$refs.exportDemo).then(function (canvas) {
                        var imgUri = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"); // 获取生成的图片的url
                        //window.location.href = imgUri; // 下载图片
                        var newImg = document.createElement("img");
                        newImg.src = imgUri;
                        var context = canvas.getContext('2d');  //取得画布的2d绘图上下文
                        context.drawImage(newImg, 0, 0);
                        var a = document.createElement('a');
                        a.href = canvas.toDataURL('image/png');  //将画布内的信息导出为png图片数据
                        a.download = "exportImgName";  //设定下载名称
                        a.click(); //点击触发下载
                    }
                );
            }
        }
    }
</script>

<style scoped>

</style>
